var render = function render(){var _vm=this,_c=_vm._self._c;return (!!_vm.mainId)?_c('a',{staticClass:"btn btn-link btn-harvest",attrs:{"href":_vm.href,"target":"_blank","title":_vm.translate('See record on Harvest')},on:{"click":function($event){$event.stopPropagation();}}},[_c('img',{attrs:{"src":require("@/assets/img/harvest-logo-icon.webp")}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }